import request from "../utils/axios";

export const getAccount = (params) => {
  return request({ method: "GET", url: "/account/info", params });
};

export const getDevices = (params) => {
  return request({ method: "GET", url: "/account/devices", params });
};

export const getPaymentComissions = (params) => {
  return request({ method: "GET", url: "/payment-comissions", params });
};

export const createPaymentComission = (data) => {
  return request({ method: "POST", url: "/payment-comissions", data });
};

export const deletePaymentComission = (id) => {
  return request({ method: "DELETE", url: `/payment-comissions/${id}` });
};

export const terminateDevice = (deviceId) => {
  return request({
    method: "POST",
    url: `/account/devices/${deviceId}/terminate`,
  });
};

export const uploadAvatar = (data) => {
  return request({
    method: "POST",
    url: "/account/images",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getStatsTransactions = (params) => {
  return request({
    method: "GET",
    url: "/analytics/stats/transactions",
    params,
  });
};

export const getStatsPaymentServices = (params) => {
  return request({
    method: "GET",
    url: "/analytics/stats/transactions/payment-services",
    params,
  });
};

export const getRevenue = (params) => {
  return request({
    method: "GET",
    url: "/analytics/list/transactions/diagram",
    params,
  });
};

export const getClickPayments = (sellerId) => {
  return request({
    method: "GET",
    url: `/sellers/${sellerId}/payment-services/click`,
  });
};

export const addClickPayments = (sellerId, data) => {
  return request({
    method: "POST",
    url: `/sellers/${sellerId}/payment-services/click`,
    data,
  });
};

export const deleteClickPayments = (sellerId, paymentServiceId) => {
  return request({
    method: "DELETE",
    url: `/sellers/${sellerId}/payment-services/click/${paymentServiceId}`,
  });
};

export const getBozorPayPayments = (sellerId) => {
  return request({
    method: "GET",
    url: `/sellers/${sellerId}/payment-services/bozor-pay`,
  });
};

export const addBozorPayPayments = (sellerId, data) => {
  return request({
    method: "POST",
    url: `/sellers/${sellerId}/payment-services/bozor-pay`,
    data,
  });
};

export const deleteBozorPayPayments = (sellerId, paymentServiceId) => {
  return request({
    method: "DELETE",
    url: `/sellers/${sellerId}/payment-services/bozor-pay/${paymentServiceId}`,
  });
};
